export default __webpack_public_path__ + "static/media/cizma13.1fb65704.jpg";